import { render } from "./FundChart.vue?vue&type=template&id=fbbc0904&scoped=true"
import script from "./FundChart.vue?vue&type=script&lang=js"
export * from "./FundChart.vue?vue&type=script&lang=js"

import "./FundChart.vue?vue&type=style&index=0&id=fbbc0904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbc0904"]])

export default __exports__